import { Link } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Nav from 'react-bootstrap/Nav'

import CreateProfileFromConfigModal from './CreateProfileFromConfigModal.jsx'
import Icon from '../../../components/Icon.jsx'

import { addNotification, NotificationTypes } from '../../../state/actions/notificationActions.js'
import { createProfile, fetchProfileList } from '../../../state/actions/profileActions.js'
import { profileListSignal } from '../../../state/signals/profileSignals.js'
import { utgSignal } from '../../../state/signals/utgSignals.js'

export default function UtgTools(props) {

    // If the parent passes a showCreateProfileSignal (e.g. UtgConfig, which renders the modal
    // outside <Loadable> to prevent it being unmounted during config reloads), use that.
    // Otherwise own the modal locally (all other UTG pages).
    const localShowModalSignal = useSignal(false)
    const showModalSignal = props.showCreateProfileSignal ?? localShowModalSignal

    const createProfileNameSignal = useSignal('')

    const profileNamesComputed = useComputed(() => {
        if (profileListSignal.value) {
            return profileListSignal.value.map((p) => p.name)
        }
        return []
    })
    const profileNameAlreadyUsedComputed = useComputed(() => {
        return profileNamesComputed.value.length && profileNamesComputed.value.includes(createProfileNameSignal.value)
    })

    const handleSubmitCreateProfileFromConfig = async () => {
        showModalSignal.value = false
        const profileConfig = {
            name: createProfileNameSignal.value,
            businessEntityId: props.beId,
            type: 1,
            config: {
                ...props.componentConfig.config,
                utgGlobal: {
                    ...props.componentConfig.config.utgGlobal,
                    ccschema: utgSignal.value.utgVersion
                }
            }
        }
        createProfile(props.beId, profileConfig, props.config, props.accessToken, false).then(
            (result) => {
                const profile = result?.componentProfile ?? result
                const profileName = createProfileNameSignal.value
                createProfileNameSignal.value = ''
                addNotification(
                    <span>Profile &quot;{profileName}&quot; successfully created. <Link to={`/be/${props.beId}/profiles/${profile.id}`}>View Profile</Link></span>,
                    NotificationTypes.SUCCESS,
                    false,
                    'Profile Created'
                )
            }
        ).catch(
            (error) => {
                showModalSignal.value = true
                addNotification(`Unable to create profile. ${error}`, NotificationTypes.ERROR, false)
            }
        )
    }

    // Action toolbar
    const handleToolSelect = item => {
        if (item == 'copyconfig') {
            // place the config data on the users clipboard if the browser supports it
            if (navigator && navigator.clipboard && navigator.clipboard.writeText)
            {
                navigator.clipboard.writeText(JSON.stringify(props.componentConfig.config, null, 2));
                addNotification(`The UTG configuration data has been copied to your clipboard.`, NotificationTypes.SUCCESS, false, 'Copy Succeeded')
            }
            else {
                addNotification('This browser does not support copying data to the clipboard.', NotificationTypes.INFO, false, 'Copy Failed')
            }
        }
        if (item == 'createprofilefromconfig') {
            fetchProfileList(props.beId, props.config, props.accessToken)
            showModalSignal.value = true
        }
        if (item == 'about') {
            console.log('not implemented yet')
        }
    }

    return (
        <>
            {/* Only render the modal here when we own it (not passed in from a parent) */}
            {!props.showCreateProfileSignal && <CreateProfileFromConfigModal
                showSignal={showModalSignal}
                newProfileNameSignal={createProfileNameSignal}
                nameAlreadyUsedComputed={profileNameAlreadyUsedComputed}
                handleSubmit={handleSubmitCreateProfileFromConfig}
                utgNickname={utgSignal.value.componentNickname}
            />}
            <Nav className="justify-content-end ms-auto" onSelect={handleToolSelect}>
            {/* <Nav.Item>
                <Nav.Link eventKey="about"><Icon icon="info-circle" width={24} height={24}></Icon> About</Nav.Link>
            </Nav.Item> */}
            <Nav.Item>
                <Nav.Link eventKey="copyconfig"><Icon icon="clipboard" width={24} height={24}></Icon> Copy Configuration</Nav.Link>
            </Nav.Item>
            {props.canCreateProfile && <Nav.Item>
                <Nav.Link eventKey="createprofilefromconfig"><Icon icon="plus-circle" width={24} height={24}></Icon> Create Profile from Configuration</Nav.Link>
            </Nav.Item>}
            </Nav>
        </>
    )
}
